import React from 'react';
import Calendar, { ICalendarProps } from '../../../components/Calendar';

import type { IBaseProps } from '@home/types/common';
import type { IRecord, IMilestoneSimpleDTO } from '@gp/types/global';
import type { IDPSReportCalendarProjectSimpleVO } from '@gp/types/dpsReport/common';
import type { ICalendarProjectMilestoneDTOV2 } from '@gp/types/dpsReport/v2';

interface ICalendarV2Props extends IBaseProps, ICalendarProps {
  projectsMilestones?: ICalendarProjectMilestoneDTOV2[];
}

const getCalendarProjects = (
  projectsMilestones?: ICalendarProjectMilestoneDTOV2[],
): IDPSReportCalendarProjectSimpleVO[] => {
  if (!Array.isArray(projectsMilestones) || !projectsMilestones.length) return [];
  return projectsMilestones.map((projectMilestone) => {
    const { details, studio_id: studioId, studio, ...restProjectMilestone } = projectMilestone || {};
    return { ...restProjectMilestone };
  });
};

const getCalendarMilestonesMapping = (
  projectsMilestones?: ICalendarProjectMilestoneDTOV2[],
): IRecord<IMilestoneSimpleDTO[]> => {
  if (!Array.isArray(projectsMilestones) || !projectsMilestones.length) return {};
  return projectsMilestones.reduce<IRecord<IMilestoneSimpleDTO[]>>((acc, cur) => {
    const { project_id: projectId, details } = cur || {};
    if (!projectId) return acc;
    if (!Array.isArray(details) || !details.length) return acc;
    const milestones = details.map<IMilestoneSimpleDTO>((detail) => {
      const { priority, business_owner: businessOwner, pteam, status, ...restDetail } = detail || {};
      return { ...restDetail };
    });
    return { ...acc, [projectId]: milestones };
  }, {});
};

const CalendarV2: React.FC<ICalendarV2Props> = (props) => {
  const { projectsMilestones, ...restProps } = props;

  const projects = getCalendarProjects(projectsMilestones);

  const milestonesMapping = getCalendarMilestonesMapping(projectsMilestones);

  return <Calendar {...restProps} projects={projects} milestonesMapping={milestonesMapping} />;
};

export default CalendarV2;
